import { ETypographyColor, ETypographySize, ETypographyWeight, Typography } from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"

import { CalendarAccount } from "../models"

import CalendarSyncAvailabilityItem from "./CalendarSyncAvailabilityItem"

import "./styles.scss"

type Props = {
    data: CalendarAccount[]
    isRedesigned?: boolean
}

export const CalendarSyncAvailability = ({ data, isRedesigned = false }: Props) => {
    return (
        <>
            {data?.map(calendar => (
                <div
                    className={buildCssClassName("sync-calendar mb-3 text-left flex flex-col gap-y-[10px]", {
                        redesigned: isRedesigned
                    })}
                    key={calendar.profileId}
                >
                    <div
                        className={buildCssClassName("py-[8px] pb-[5px]", {
                            "w-full border-b-[1px] border-b-blue-500": isRedesigned
                        })}
                    >
                        <Typography
                            text={calendar.profileName}
                            size={ETypographySize.Small}
                            weight={ETypographyWeight.Bold}
                            color={ETypographyColor.Black}
                        />
                    </div>

                    {calendar?.profileCalendars?.map(profile => (
                        <CalendarSyncAvailabilityItem
                            withRedesignedSwitchers={isRedesigned}
                            name={profile.calendarId}
                            profile={profile}
                        />
                    ))}
                </div>
            ))}
        </>
    )
}
